export default __webpack_public_path__ + "static/media/learose4-768w.eec87265.webp";